import * as React from "react";
import "./styles.scss";
import KamiKodeLogo from "../../assets/images/logoDarkWide.png";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import CustomButton from "../custom-button";

const pages = [
	{ title: "About Us", id: "about-us" },
	{ title: "What we offer", id: "what-we-offer" },
];

const NavBar = () => {
	const [anchorElNav, setAnchorElNav] = React.useState(null);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};
	const handleScrollTo = (id) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
			handleCloseNavMenu();
		}
	};
	return (
		<AppBar position="static">
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					<Box
						component="img"
						className="kamiLogo"
						src={KamiKodeLogo}
						alt="The KamiKode Logo"
						sx={{ display: { xs: "none", md: "flex" } }}
					/>

					<Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleOpenNavMenu}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorElNav}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							open={Boolean(anchorElNav)}
							onClose={handleCloseNavMenu}
							sx={{
								display: { xs: "block", md: "none" },
							}}
						>
							{pages.map((page) => (
								<MenuItem key={page.id} onClick={() => handleScrollTo(page.id)}>
									<Typography textAlign="center" color="secondary">
										{page.title}
									</Typography>
								</MenuItem>
							))}
						</Menu>
						<Box
							width="100%"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							<Box
								component="img"
								className="kamiLogo"
								src={KamiKodeLogo}
								alt="The KamiKode Logo"
								sx={{ display: { xs: "flex", md: "none" } }}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							justifyContent: "flex-end",
							flexGrow: 1,
							display: { xs: "none", md: "flex" },
							pr: "20px",
							gap: "40px",
						}}
					>
						{pages.map((page) => (
							<MenuItem key={page.id} onClick={() => handleScrollTo(page.id)}>
								<Typography textAlign="center" color="secondary">
									{page.title}
								</Typography>
							</MenuItem>
						))}
					</Box>

					<Box sx={{ flexGrow: 0 }}>
						<Tooltip
							title="Contact Us"
							onClick={() => {
								handleScrollTo("contact-us");
							}}
						>
							<CustomButton
								color="buttonMain"
								handleScrollTo={handleScrollTo}
								scrollTo="contact-us"
								label="Let's Talk"
							/>
						</Tooltip>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
	);
};

export default NavBar;
